<script>
  export default {
    props: {
      color: {
        type: String,
        required: false,
        default: "var(--neutral-500)",
      },
    },
  };
</script>

<template>
  <svg
    width="12" height="12"
    viewBox="0 0 12 12" fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_12784_9514)">
      <path
        d="M5.24508 1.11503L2.75008 2.05503C2.17508 2.27003 1.70508 2.95003 1.70508
                3.56003V7.27503C1.70508 7.86503 2.09508 8.64003 2.57008 8.99503L4.72008 10.6C5.42508 11.13
                6.58508 11.13 7.29008 10.6L9.44008 8.99503C9.91508 8.64003 10.3051 7.86503 10.3051
                7.27503V3.56003C10.3051 2.94503 9.83508 2.26503 9.26008 2.05003L6.76508 1.11503C6.34008 0.960029 5.66008 0.960029 5.24508 1.11503Z"
        :stroke="color" stroke-width="1.5"
        stroke-linecap="round" stroke-linejoin="round"
      />
      <path
        d="M6 6.25C6.55228 6.25 7 5.80228 7 5.25C7 4.69772 6.55228 4.25 6 4.25C5.44772 4.25 5 4.69772 5 5.25C5 5.80228 5.44772 6.25 6 6.25Z"
        :stroke="color" stroke-width="1.5"
        stroke-miterlimit="10" stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 6.25V7.75" stroke="#F79009"
        stroke-width="1.5" stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_12784_9514">
        <rect
          width="12" height="12"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
